/*
 * Shared table/pagination defaults so every list uses the same options and the
 * value is not re-typed as a magic literal in each module.
 */
export const ROWS_PER_PAGE_OPTIONS = [10, 50, 100];
